import { render } from "./ClassOne.vue?vue&type=template&id=2ab3ff54&scoped=true"
import script from "./ClassOne.vue?vue&type=script&lang=ts"
export * from "./ClassOne.vue?vue&type=script&lang=ts"

import "./ClassOne.vue?vue&type=style&index=0&id=2ab3ff54&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2ab3ff54"

export default script